import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import moment from "moment";

const TablaEditarLotes = ({ datos }) => {
    const { token } = useContextUsuario();
    const { setListaProductos, ActualizarLista } = useContextEmpleado();
    const tableRef = useRef();
    const tableInstance = useRef(null);
    const navigate = useNavigate();

    const handleEditarLote = useCallback((rowData) => {
        navigate(`/app/admin/lotes/gestionar/${rowData.productoId}/${rowData.IdLote}`, {
            state: { datos: rowData.productoCompleto, loteIdSeleccionado: rowData.IdLote }
        });
    }, [navigate]);


    useEffect(() => {
        if (!datos || datos.length === 0) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
                $(tableRef.current).empty();
            }
            return;
        }

        const requiredFields = ['productoNombre', 'IdLote', 'NombreLote', 'ExistenciaTotal', 'EstadoLote'];
        const missingFields = requiredFields.filter(field => !datos[0]?.hasOwnProperty(field));
        if (datos.length > 0 && missingFields.length > 0) {
            console.error(`Los datos no contienen las propiedades requeridas: ${missingFields.join(', ')}`);
            return;
        }

        if (tableInstance.current) {
            tableInstance.current.destroy();
            tableInstance.current = null;
        }

        const columnDefinition = [
            {
                data: 'productoNombre',
                title: 'Producto'
            },
            {
                data: 'IdLote',
                title: 'ID Lote',
                visible: false 
            },
            {
                data: 'NombreLote',
                title: 'Nombre Lote'
            },
            {
                data: 'ExistenciaTotal',
                title: 'Existencia'
            },
            {
                data: 'EstadoLote',
                title: 'Estado'
            },
            {
                data: 'FechaIngreso',
                title: 'Fec. Ingreso',
                render: (data) => {
                    const fecha = moment(data);
                    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : 'N/A';
                }
            },
            {
                data: 'UltimaAsignacion',
                title: 'Última Asig.',
                // También usamos moment para formatear la última asignación
                render: (data) => {
                    if (data === 'N/A') return 'N/A';
                    const fecha = moment(data);
                    return fecha.isValid() ? fecha.format('DD/MM/YYYY') : 'N/A';
                }
            },
            {
                data: null,
                title: 'Acciones',
                orderable: false,
                className: 'dt-center all',
                render: () => `
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                    <button class="btn btn-outline-primary btn-sm edit-lote">
                        <i class="fas fa-edit"></i>
                    </button>
                </div>
                `,
            },
        ];

        tableInstance.current = $(tableRef.current).DataTable({
            data: datos,
            columns: columnDefinition,
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'l><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 a 0 de 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "Sin resultados encontrados",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            lengthMenu: [
                [5, 10, 25, 50, -1],
                [5, 10, 25, 50, "Todos"]
            ],
            stateSave: false,
            destroy: true,
            responsive: true,
        });

        // Delegación de eventos para la edición.
        $(tableRef.current).on('click', 'button.edit-lote', function () {
            const tr = $(this).closest('tr');
            const row = tableInstance.current.row(tr);
            const rowData = row.data();

            handleEditarLote(rowData);
        });


        return () => {
            $(tableRef.current).off('click', 'button.edit-lote');

            if (tableInstance.current) {
                tableInstance.current.destroy();
                tableInstance.current = null;
            }
        };

    }, [datos, navigate, token, setListaProductos, ActualizarLista, handleEditarLote]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id="productoslotes"
                className="table table-bordered table-hover nowrap"
                style={{ width: "100%" }}
            >
            </table>
        </div>
    );
};

export default TablaEditarLotes;